// extracted by mini-css-extract-plugin
module.exports = {"card":"LicenseCard_card__2r_82","rowHeader":"LicenseCard_rowHeader__2Gu2D","row":"LicenseCard_row__1wGNP"};